import { render, staticRenderFns } from "./brandPublicity.vue?vue&type=template&id=e230d116&scoped=true&"
import script from "./brandPublicity.vue?vue&type=script&lang=js&"
export * from "./brandPublicity.vue?vue&type=script&lang=js&"
import style0 from "./brandPublicity.vue?vue&type=style&index=0&id=e230d116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e230d116",
  null
  
)

export default component.exports